module.exports = __webpack_public_path__ + "static/img/Access Token.404496a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Access Token.jpg
// module id = 317
// module chunks = 4